import React from "react";
import { Eyebrow } from "./_shared";
import { useTheme } from "../../theme/ThemeProvider";

const ABOUT_IMAGE =
  "https://images.pexels.com/photos/4412921/pexels-photo-4412921.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=940";

export default function About() {
  const { theme } = useTheme();
  const bold = theme === "bold";

  return (
    <section
      id="about"
      data-testid="about-section"
      className="py-24 lg:py-32 bg-cream-50 border-y border-cream-300"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          <div className="lg:col-span-5 reveal">
            <div className="relative aspect-[4/5] overflow-hidden">
              <img
                src={ABOUT_IMAGE}
                alt="Quiet contemporary office space"
                className="absolute inset-0 w-full h-full object-cover"
              />
              {bold && (
                <>
                  <div className="absolute -right-6 -top-6 w-28 h-28 bg-ochre-500" aria-hidden="true" />
                  <div className="absolute -left-6 -bottom-6 w-20 h-20 bg-rust-500" aria-hidden="true" />
                </>
              )}
            </div>
            <p className="mt-6 text-[11px] uppercase tracking-[0.22em] text-charcoal-muted font-sans">
              The Practice — Lagos
            </p>
          </div>

          <div className="lg:col-span-7 reveal">
            <Eyebrow>About the Firm</Eyebrow>
            <h2 className="mt-4 font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tight text-charcoal leading-[1.05]">
              Grace and strength,
              <span className="block italic text-sage-600">in service of others.</span>
            </h2>

            <div className="mt-10 space-y-6 max-w-2xl text-charcoal-muted font-sans text-[15px] sm:text-base leading-relaxed">
              <p>
                Charis &amp; Mettle is a transactional law practice for
                founders, operators, boards, and investors. We are deliberately
                small, deeply experienced, and structured to be present for the
                conversations that matter — the ones where the deal, the
                document, and the relationship all need to land in the same
                place.
              </p>
              <p>
                <span className="font-serif text-charcoal italic">Charis</span>{" "}
                is a Greek word that means "grace." It is a dynamic expression
                of divine kindness and benevolence that has actively shaped our
                path. It represents a quiet force that opens doors and sustains
                through adversity.{" "}
                <span className="font-serif text-charcoal italic">Mettle</span>{" "}
                speaks to inner strength — courage under pressure, resilience in
                the face of opposition, and the tested character that is
                revealed, not in ease, but in challenge. It represents the
                forged quality of a person who has endured, adapted, and
                remained steadfast.
              </p>
              <p>
                Together, Charis &amp; Mettle reflects a dual truth about our
                journey — the fact that our path has been neither accidental nor
                solely self-made. It is the convergence of divine grace and
                cultivated strength. Our counsel is not only technically sound,
                but shaped by depth of character, moral clarity, and an ability
                to stand firm in complex, high-stakes situations.
              </p>
              <p>
                Charis &amp; Mettle is not just a brand. It is a testimony that
                tells the story of legal practitioners whose lives and careers
                have been guided by grace and proven by strength, and who now
                bring both to bear in the service of others.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
